import { render } from "./newVerre.vue?vue&type=template&id=2172a8a6&scoped=true"
import script from "./newVerre.vue?vue&type=script&lang=js"
export * from "./newVerre.vue?vue&type=script&lang=js"

import "./newVerre.vue?vue&type=style&index=0&id=2172a8a6&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172a8a6"]])

export default __exports__